import emailjs from "@emailjs/browser";
import { useRef, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Footer from "../components/Footer";
// import Iframe from "../components/Iframe";
import MenuDesktopHorizontal from "../components/MenuDesktopHorizontal";

const Contact = () => {
  // const [map, setMap] = useState("");
  const [form_name, setForm_name] = useState("");
  const [reply_to, setReply_to] = useState("");
  const [message, setMessage] = useState("");
  const form = useRef();

  // gerer les notification des email envoyer
  const notify = () => {
    toast.success("Message envoyer avec succès", {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  // gerer les email envoyer
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_jypef4s",
        "template_4wdnsuv",
        form.current,
        "ENWhELaCEiT_iLeD1"
      )
      .then(
        () => {
          setForm_name("");
          setReply_to("");
          setMessage("");
          notify();
        },
        () => {
          toast.error("Une erreur est survenue. Merci de réessayer.", {
            position: "top-center",
            autoClose: 5000,
            theme: "colored",
          });
        }
      );
  };

  return (
    <div className="flex flex-col items-center w-full relative">
      <div className="flex flex-col w-full relative pb-20 lg:pb-6 px-8 lg:px-4 max-w-2xl lg:max-w-4xl 2xl:max-w-6xl ecran-2000:max-w-7xl">
        <MenuDesktopHorizontal />

        <div className="pt-24 lg:pt-6 relative flex flex-col items-center w-full text-white space-y-8 max-w-2xl lg:max-w-4xl 2xl:max-w-6xl ecran-2000:max-w-7xl">
          <ToastContainer />
          <span
            className="texte-box-rouge text-4xl relative text-[#f77669] mt-[0!important] tracking-tighter font-semibold font-[Yanone Kaffeesatz] after:content-[''] 
              after:absolute after:block after:h-1 after:bg-[#f77669] 
              after:w-full"
          >
            Contacts
          </span>
          <div className="w-full flex flex-col items-center space-y-4">
            {/* <Iframe /> */}
            <ul className="grid gap-2 grid-cols-1 md:gap-x-4 lg:gap-x-0 md:grid-cols-2 w-full">
              <li className="flex space-x-2">
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="w-6 h-6 text-[#82aac1]"
                  >
                    <path
                      fillRule="evenodd"
                      d="M11.54 22.351l.07.04.028.016a.76.76 0 00.723 0l.028-.015.071-.041a16.975 16.975 0 001.144-.742 19.58 19.58 0 002.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 00-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 002.682 2.282 16.975 16.975 0 001.145.742zM12 13.5a3 3 0 100-6 3 3 0 000 6z"
                      clipRule="evenodd"
                    />
                  </svg>
                </span>
                <span className="text-gray-300">Abidjan, Côte d'Ivoire</span>
              </li>
              <li className="flex flex-wrap space-x-2">
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="w-6 h-6 text-[#82aac1]"
                  >
                    <path d="M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a3 3 0 01-3.144 0L1.5 8.67z" />
                    <path d="M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a1.5 1.5 0 001.572 0L22.5 6.908z" />
                  </svg>
                </span>
                <span className="text-gray-300">amarafofana121@gmail.com</span>
              </li>
              <li className="flex space-x-2">
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="w-6 h-6 text-[#82aac1]"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1.5 4.5a3 3 0 013-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 01-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 006.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 011.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 01-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5z"
                      clipRule="evenodd"
                    />
                  </svg>
                </span>
                <span className="text-gray-300">+225 07 87 93 32 96</span>
              </li>
              <li className="flex space-x-2">
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="w-6 h-6 text-[#82aac1]"
                  >
                    <path
                      fillRule="evenodd"
                      d="M6.75 2.25A.75.75 0 017.5 3v1.5h9V3A.75.75 0 0118 3v1.5h.75a3 3 0 013 3v11.25a3 3 0 01-3 3H5.25a3 3 0 01-3-3V7.5a3 3 0 013-3H6V3a.75.75 0 01.75-.75zm13.5 9a1.5 1.5 0 00-1.5-1.5H5.25a1.5 1.5 0 00-1.5 1.5v7.5a1.5 1.5 0 001.5 1.5h13.5a1.5 1.5 0 001.5-1.5v-7.5z"
                      clipRule="evenodd"
                    />
                  </svg>
                </span>
                <span className="text-gray-300">disponible</span>
              </li>
            </ul>
          </div>
          <div className="flex flex-col space-y-2">
            <span className="text-4xl text-[#c792cf] font-semibold tracking-tighter font-[Yanone Kaffeesatz]">Contactez moi</span>
            <p className="text-gray-300 text-xs select-none">
              Je suis intéressé par les opportunités de freelance - en
              particulier les projets ambitieux ou de grande envergure.
              Cependant, si vous avez d'autres demandes ou questions, n'hésitez
              pas à utiliser le formulaire.
            </p>
          </div>
          <form
            ref={form}
            onSubmit={sendEmail}
            className="w-full flex flex-col space-y-3"
          >
            <input type="hidden" name="to_name" value="Amara Fofana" />
            <div className="space-y-3  md:space-y-0 md:flex md:space-x-3 w-full">
              <input
                type="text"
                className="w-full h-12 bg-transparent rounded-md pl-4 outline-none border-2 border-gray-500 focus:border-[#82aac1]"
                placeholder="Nom"
                name="form_name"
                value={form_name}
                onChange={(e) => setForm_name(e.target.value)}
                required
              />
              <input
                type="email"
                className="w-full h-12 bg-transparent rounded-md pl-4 outline-none border-2 border-gray-500 focus:border-[#82aac1]"
                placeholder="Email"
                name="reply_to"
                value={reply_to}
                onChange={(e) => setReply_to(e.target.value)}
                required
              />
            </div>
            <textarea
              type="text"
              style={{ minHeight: "112px", maxHeight: "350px" }}
              className="w-full h-28 bg-transparent rounded-md pl-4 outline-none border-2 border-gray-500 focus:border-[#82aac1]"
              placeholder="Messages"
              name="message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
            />
            <input
              type="submit"
              className="bg-[#82aac1] h-12 rounded-md text-lg md:w-60 cursor-pointer"
              value="Envoyer"
            />
          </form>
        </div>
      
      {/* footer */}
      <div className="lg:hidden pt-4">
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Contact;
